import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import { DsSkeletonBox } from '@coloplast/design-system';
import 'shared/styles/components/_c-content-library-page.scss';
import '@coloplast/design-system/dist/components/skeleton/ds-skeleton.css';

const heroHeaderSearchWrapper = document.getElementById('hero-header-search-wrapper');
if (heroHeaderSearchWrapper) {
    const app = createApp({
        name: 'HeroHeaderSearchWrapper',
    });
    app.use(store);
    app.component('ds-skeleton-box', DsSkeletonBox);
    app.component('content-library', defineAsyncComponent(
        () => import(/* webpackChunkName: "content-library" */ 'shared/components/contentLibrary/contentLibrary.vue')
    ));
    app.mount(heroHeaderSearchWrapper);
}